<template>
  <div>
    <!-- eslint-disable-next-line -->
    <div v-for="alert in $store.state.Dialog.alertDialogs">
      <v-dialog v-model="alert.isAlert" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{ alert.title }}</v-card-title>
          <v-card-text>{{ alert.content }}</v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn :disabled="$store.getters['Ajax/loading']" color="accent" text @click="$store.commit('RESOLVE_ALERT', alert)">{{ $t("global.ok") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertDialog"
};
</script>

<style scoped />
